<template>
  <div>
    <div v-if="item" v-html="contentBlock"></div>
  </div>
</template>

<script>
import marked from 'marked'
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ContentBlock",
  mixins: [
    CrudOperationsMixin
  ],
  props: [
    'name',
    'tokens',
  ],
  data() {
    return {
      item: null,
    };
  },
  computed: {
    contentBlock: function () {
      let value = this.item.value;

      if (this.tokens) {
        let keys = Object.keys(this.tokens);

        for (let i = 0; i < keys.length; ++i) {
          let key = keys[i];
          value = value.replace('%' + key + '%', this.tokens[key]);
        }
      }

      return marked(value);
    }
  },
  methods: {
    load: function () {

      this.readQuery('/graphql/public', {
          query: `
            query ($filter: String) {
              contentBlocks (filter: $filter) {
                id,
                value
              }
            }`,
          variables: {
            'filter': 'name = "' + this.name + '"'
          }
        }, (data) => {
          if (data.contentBlocks && data.contentBlocks.length == 1)
            this.item = data.contentBlocks[0];
          else
            this.item = null;
        });
    }
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>